import AiOldPhotoRestorationIcon from '../assets/svg/ai-old-photo-restoration.svg?react';
import AiFaceSwapIcon from '../assets/svg/ai-face-swap.svg?react';
import AiPhotoColorizerIcon from '../assets/svg/ai-photo-colorizer.svg?react';
import AiImageGeneratorIcon from '../assets/svg/ai-image-generator.svg?react';
import AiImageUpscalerIcon from '../assets/svg/ai-image-upscaler.svg?react';
import AiImageToImageIcon from '../assets/svg/ai-image-to-image.svg?react';
import AiImageExtenderIcon from '../assets/svg/ai-image-extender.svg?react';
import AiObjectEraserIcon from '../assets/svg/ai-object-eraser-icon.svg?react';
import AiVideoGeneratorIcon from '../assets/svg/ai-video-generator.svg?react';
import AiImageBgRemoverIcon from '../assets/svg/bg-remove.svg?react';
import AiClothesChangerIcon from '../assets/svg/ai-clothes-changer.svg?react';
import FJAiTextToVideoIcon from '../assets/svg/aiGeneratorVideo/ai-text-to-video.svg?react';
import FJAiRecapIcon from '../assets/svg/aiGeneratorVideo/ai-recap.svg?react';
import FJAiImageToVideoIcon from '../assets/svg/aiGeneratorVideo/ai-image-to-video.svg?react';
import FJAiEffectsToVideoIcon from '../assets/svg/aiGeneratorVideo/ai-video-effect.svg?react';
import AiFake3dIcon from '../assets/svg/fake-3d.svg?react';
import AiAudioGeneratorIcon from '../assets/svg/ai-music.svg?react';
import AiVideoRemoveBgIcon from '../assets/svg/video-background-remover.svg?react';
import AiVideoToAISfxGeneratorIcon from '../assets/svg/video-to-ai-sfx.svg?react';
import AITextBasedEditingIcon from '../assets/svg/ai-text-based-editing.svg?react';
import FJTextToFullVideoIcon from '../assets/svg/textToVideo/text-to-full-video.svg?react';
import FJBlogUrlToVideoIcon from '../assets/svg/textToVideo/blog-url-to-video.svg?react';
import FJProductUrlToAdsIcon from '../assets/svg/textToVideo/product-url-to-ads.svg?react';
import FJPptToVideoIcon from '../assets/svg/textToVideo/ppt-to-video.svg?react';
import FJTextToSpeechIcon from '../assets/svg/ttv/text-to-speech.svg?react';
import FJCloneVoiceIcon from '../assets/svg/ttv/clone-voice.svg?react';
import AIHairstyleChangerIcon from '../assets/svg/ai-hairstyle-changer.svg?react';
import AiWatermarkRemoverIcon from '../assets/svg/watermark-remove.svg?react';
import AiPhotoEditorIcon from '../assets/svg/photo-editor.svg?react';
import AIHeadshotGeneratorIcon from '../assets/svg/ai-headshot.svg?react';
import FJAIVideoClipsIcon from '../assets/svg/aiVideoClip/ai-video-clips.svg?react';
import FJLongVideoIcon from '../assets/svg/aiVideoClip/long-video-to-shorts.svg?react';

import { RELEASE } from '../constants/FJEvnConstant';
import { AI_GENERATOR_VIDEO_TAB_TYPE } from './dataConfig/FJAIVideoGeneratorData.js';
const environment = import.meta.env.MODE;
const isRelease = environment !== RELEASE;
const FJHeaderConfig = {
    // 电脑端菜单列表(从上到下，从左到右排列), 新增工具需要到less文件修改gird布局
    aiMenuList: [
        {
            hasMobile: true,
            title: 'ai-image-to-image',
            icon: AiImageToImageIcon,
            href: isRelease ? '/apply/image-to-image/' : '/ai/image-to-image/',
        },
        {
            title: '3d-photo-animation',
            icon: AiFake3dIcon,
            href: isRelease ? '/apply/3d-photo-animation/' : '/ai/3d-photo-animation/',
        },
        {
            hasMobile: true,
            title: 'ai-text-to-image',
            icon: AiImageGeneratorIcon,
            href: isRelease ? '/apply/text-to-image/' : '/ai/text-to-image/',
        },
        {
            hasMobile: true,
            title: 'ai-old-photo-restoration',
            icon: AiOldPhotoRestorationIcon,
            href: isRelease ? '/apply/old-photo-restoration/' : '/ai/old-photo-restoration/',
        },
        {
            hasMobile: true,
            title: 'ai-face-swap',
            icon: AiFaceSwapIcon,
            href: isRelease ? '/apply/face-swap/' : '/ai/face-swap/',
        },
        {
            hasMobile: true,
            title: 'ai-image-extender',
            icon: AiImageExtenderIcon,
            href: isRelease ? '/apply/image-extender/' : '/ai/image-extender/',
        },
        {
            hasMobile: false,
            title: 'ai-clothes-changer',
            icon: AiClothesChangerIcon,
            href: isRelease ? '/apply/clothes-changer/' : '/ai/clothes-changer/',
        },
        {
            hasMobile: true,
            title: 'ai-object-eraser',
            icon: AiObjectEraserIcon,
            href: isRelease ? '/apply/object-remover/' : '/ai/object-remover/',
        },
        {
            title: 'ai-image-bg-remover',
            icon: AiImageBgRemoverIcon,
            href: isRelease ? '/apply/image-background-remover/' : '/ai/image-background-remover/',
        },
        {
            hasMobile: true,
            title: 'ai-image-upscaler',
            icon: AiImageUpscalerIcon,
            href: isRelease ? '/apply/image-upscaler/' : '/ai/image-upscaler/',
        },
        {
            hasMobile: true,
            title: 'ai-photo-colorizer',
            icon: AiPhotoColorizerIcon,
            href: isRelease ? '/apply/photo-colorizer/' : '/ai/photo-colorizer/',
        },
        {
            title: 'ai-text-to-speech',
            icon: FJTextToSpeechIcon,
            href: isRelease ? '/apply/text-to-speech/' : '/ai/text-to-speech/',
        },
        {
            title: 'ai-voice-cloning',
            icon: FJCloneVoiceIcon,
            href: isRelease ? '/apply/voice-cloning/' : '/ai/voice-cloning/',
        },

        {
            title: 'ai-video-generator',
            icon: AiVideoGeneratorIcon,
            href: isRelease ? '/apply/video-generator/' : '/ai/video-generator/',
        },
        {
            title: AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO,
            icon: FJAiImageToVideoIcon,
            href: isRelease ? '/apply/video-generator/image-to-video/' : '/ai/video-generator/image-to-video/',
        },
        {
            title: AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO,
            icon: FJAiTextToVideoIcon,
            href: isRelease ? '/apply/video-generator/text-to-video/' : '/ai/video-generator/text-to-video/',
        },
        {
            title: AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO,
            icon: FJAiEffectsToVideoIcon,
            href: isRelease ? '/apply/video-generator/video-effect/' : '/ai/video-generator/video-effect/',
        },
        {
            title: 'ai-text-to-full-video',
            icon: FJTextToFullVideoIcon,
            href: isRelease ? '/apply/text-to-full-video/' : '/ai/text-to-full-video/',
        },
        {
            title: 'ai-blog-url-to-video',
            icon: FJBlogUrlToVideoIcon,
            href: isRelease ? '/apply/blog-url-to-video/' : '/ai/blog-url-to-video/',
        },
        {
            title: 'ai-product-url-to-video',
            icon: FJProductUrlToAdsIcon,
            href: isRelease ? '/apply/product-url-to-ads/' : '/ai/product-url-to-ads/',
        },
        {
            title: 'ai-ppt-to-video',
            icon: FJPptToVideoIcon,
            href: isRelease ? '/apply/ppt-to-video/' : '/ai/ppt-to-video/',
        },

        {
            title: 'ai-music-generator',
            icon: AiAudioGeneratorIcon,
            href: isRelease ? '/apply/music-generator/' : '/ai/music-generator/',
        },
        {
            title: 'ai-video-bg-remover',
            icon: AiVideoRemoveBgIcon,
            href: isRelease ? '/apply/video-background-remover/' : '/ai/video-background-remover/',
        },
        {
            title: 'ai-video-dub',
            icon: AiVideoToAISfxGeneratorIcon,
            href: isRelease ? '/apply/video-to-ai-sfx-generator/' : '/ai/video-to-ai-sfx-generator/',
        },
        {
            title: 'ai-text-based-editing',
            icon: AITextBasedEditingIcon,
            href: isRelease ? '/apply/ai-text-based-editing/' : '/ai/ai-text-based-editing/',
        },
        {
            title: 'ai-watermark-remover',
            icon: AiWatermarkRemoverIcon,
            href: isRelease ? '/apply/watermark-remover/' : '/ai/watermark-remover/',
        },
        {
            title: 'ai-hairstyle-changer',
            icon: AIHairstyleChangerIcon,
            href: isRelease ? '/apply/hairstyle-changer/' : '/ai/hairstyle-changer/',
        },
        {
            title: 'ai-photo-editor',
            icon: AiPhotoEditorIcon,
            href: isRelease ? '/apply/photo-editor/' : '/ai/photo-editor/',
        },
        {
            title: 'ai-headshot-generator',
            icon: AIHeadshotGeneratorIcon,
            href: isRelease ? '/apply/headshot-generator/' : '/ai/headshot-generator/',
        },

        {
            title: 'auto-edit',
            icon: FJAIVideoClipsIcon,
            href: isRelease ? '/apply/auto-edit/' : '/ai/auto-edit/',
        },
        {
            title: 'ai-long-video-to-shorts',
            icon: FJLongVideoIcon,
            href: isRelease ? '/apply/ai-long-video-to-shorts/' : '/ai/ai-long-video-to-shorts/',
        },
    ],
    // 移动端菜单列表(从上到下排列)
    mobileMenuList: [
        {
            title: 'ai-old-photo-restoration',
            icon: AiOldPhotoRestorationIcon,
            href: isRelease ? '/apply/old-photo-restoration/' : '/ai/old-photo-restoration/',
        },
        {
            title: 'ai-face-swap',
            icon: AiFaceSwapIcon,
            href: isRelease ? '/apply/face-swap/' : '/ai/face-swap/',
        },
        {
            title: 'ai-photo-colorizer',
            icon: AiPhotoColorizerIcon,
            href: isRelease ? '/apply/photo-colorizer/' : '/ai/photo-colorizer/',
        },
        {
            title: 'ai-text-to-image',
            icon: AiImageGeneratorIcon,
            href: isRelease ? '/apply/text-to-image/' : '/ai/text-to-image/',
        },
        {
            title: 'ai-image-upscaler',
            icon: AiImageUpscalerIcon,
            href: isRelease ? '/apply/image-upscaler/' : '/ai/image-upscaler/',
        },
        {
            title: 'ai-image-to-image',
            icon: AiImageToImageIcon,
            href: isRelease ? '/apply/image-to-image/' : '/ai/image-to-image/',
        },
        {
            title: 'ai-image-extender',
            icon: AiImageExtenderIcon,
            href: isRelease ? '/apply/image-extender/' : '/ai/image-extender/',
        },
        {
            title: 'ai-object-eraser',
            icon: AiObjectEraserIcon,
            href: isRelease ? '/apply/object-remover/' : '/ai/object-remover/',
        },
    ],
};
export const FJHeaderTools = [
    {
        groupName: 'video-group',
        children: [
            // {
            //     title: AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO,
            //     icon: FJAiImageToVideoIcon,
            //     href: isRelease ? '/apply/video-generator/image-to-video/' : '/ai/video-generator/image-to-video/',
            // },

            // {
            //     title: 'ai-long-video-to-shorts',
            //     icon: FJLongVideoIcon,
            //     href: isRelease ? '/apply/long-video-to-shorts/' : '/ai/long-video-to-shorts/',
            //     hasBeta: true,
            //     isNewWindow: true,
            // },
            {
                title: 'ai-video-generator',
                icon: FJAiTextToVideoIcon,
                href: isRelease ? '/apply/video-generator/' : '/ai/video-generator/',
            },
            {
                title: 'ai-recap',
                icon: FJAiRecapIcon,
                href: '/editor/app?ai_type=2&analytic_recap_page=ai_tools_tab_dropdown',
            },
            {
                title: AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO,
                icon: FJAiEffectsToVideoIcon,
                href: isRelease ? '/apply/video-generator/video-effect/' : '/ai/video-generator/video-effect/',
            },
            {
                title: 'ai-text-to-full-video',
                icon: FJTextToFullVideoIcon,
                href: isRelease ? '/apply/text-to-full-video/' : '/ai/text-to-full-video/',
            },
            {
                title: 'auto-edit',
                icon: FJAIVideoClipsIcon,
                href: isRelease ? '/apply/auto-edit/' : '/ai/auto-edit/',
                hasBeta: false,
                isNewWindow: true,
            },
            {
                title: 'ai-blog-url-to-video',
                icon: FJBlogUrlToVideoIcon,
                href: isRelease ? '/apply/blog-url-to-video/' : '/ai/blog-url-to-video/',
            },
            {
                title: 'ai-product-url-to-video',
                icon: FJProductUrlToAdsIcon,
                href: isRelease ? '/apply/product-url-to-ads/' : '/ai/product-url-to-ads/',
            },
            {
                title: 'ai-ppt-to-video',
                icon: FJPptToVideoIcon,
                href: isRelease ? '/apply/ppt-to-video/' : '/ai/ppt-to-video/',
            },
            {
                title: 'ai-video-bg-remover',
                icon: AiVideoRemoveBgIcon,
                href: isRelease ? '/apply/video-background-remover/' : '/ai/video-background-remover/',
            },
            {
                title: '3d-photo-animation',
                icon: AiFake3dIcon,
                href: isRelease ? '/apply/3d-photo-animation/' : '/ai/3d-photo-animation/',
            },
            {
                title: 'ai-text-based-editing',
                icon: AITextBasedEditingIcon,
                href: isRelease ? '/apply/ai-text-based-editing/' : '/ai/ai-text-based-editing/',
            },
            {
                title: 'ai-video-dub',
                icon: AiVideoToAISfxGeneratorIcon,
                href: isRelease ? '/apply/video-to-ai-sfx-generator/' : '/ai/video-to-ai-sfx-generator/',
            },
        ],
    },
    {
        groupName: 'image-group',
        children: [
            {
                hasMobile: true,
                title: 'ai-image-to-image',
                icon: AiImageToImageIcon,
                href: isRelease ? '/apply/image-to-image/' : '/ai/image-to-image/',
            },
            {
                hasMobile: true,
                title: 'ai-text-to-image',
                icon: AiImageGeneratorIcon,
                href: isRelease ? '/apply/text-to-image/' : '/ai/text-to-image/',
                titleSuffix: ' 🍌',
            },
            {
                hasMobile: false,
                title: 'ai-photo-editor',
                icon: AiPhotoEditorIcon,
                href: isRelease ? '/apply/photo-editor/' : '/ai/photo-editor/',
                titleSuffix: ' 🍌',
            },
            {
                hasMobile: false,
                title: 'ai-headshot-generator',
                icon: AIHeadshotGeneratorIcon,
                href: isRelease ? '/apply/headshot-generator/' : '/ai/headshot-generator/',
            },
            {
                title: 'ai-image-bg-remover',
                icon: AiImageBgRemoverIcon,
                href: isRelease ? '/apply/image-background-remover/' : '/ai/image-background-remover/',
            },
            {
                hasMobile: true,
                title: 'ai-old-photo-restoration',
                icon: AiOldPhotoRestorationIcon,
                href: isRelease ? '/apply/old-photo-restoration/' : '/ai/old-photo-restoration/',
            },
            {
                hasMobile: false,
                title: 'ai-clothes-changer',
                icon: AiClothesChangerIcon,
                href: isRelease ? '/apply/clothes-changer/' : '/ai/clothes-changer/',
            },
            {
                hasMobile: true,
                title: 'ai-face-swap',
                icon: AiFaceSwapIcon,
                href: isRelease ? '/apply/face-swap/' : '/ai/face-swap/',
            },
            {
                hasMobile: true,
                title: 'ai-image-upscaler',
                icon: AiImageUpscalerIcon,
                href: isRelease ? '/apply/image-upscaler/' : '/ai/image-upscaler/',
            },
            {
                hasMobile: true,
                title: 'ai-photo-colorizer',
                icon: AiPhotoColorizerIcon,
                href: isRelease ? '/apply/photo-colorizer/' : '/ai/photo-colorizer/',
            },
            {
                hasMobile: true,
                title: 'ai-image-extender',
                icon: AiImageExtenderIcon,
                href: isRelease ? '/apply/image-extender/' : '/ai/image-extender/',
            },
            {
                hasMobile: true,
                title: 'ai-object-eraser',
                icon: AiObjectEraserIcon,
                href: isRelease ? '/apply/object-remover/' : '/ai/object-remover/',
            },
            {
                title: 'ai-watermark-remover',
                icon: AiWatermarkRemoverIcon,
                href: isRelease ? '/apply/watermark-remover/' : '/ai/watermark-remover/',
            },
            {
                hasMobile: false,
                title: 'ai-hairstyle-changer',
                icon: AIHairstyleChangerIcon,
                href: isRelease ? '/apply/hairstyle-changer/' : '/ai/hairstyle-changer/',
            },
        ],
    },
    {
        groupName: 'audio-group',
        children: [
            {
                title: 'ai-music-generator',
                icon: AiAudioGeneratorIcon,
                href: isRelease ? '/apply/music-generator/' : '/ai/music-generator/',
            },
            {
                title: 'ai-text-to-speech',
                icon: FJTextToSpeechIcon,
                href: isRelease ? '/apply/text-to-speech/' : '/ai/text-to-speech/',
            },
            {
                title: 'ai-voice-cloning',
                icon: FJCloneVoiceIcon,
                href: isRelease ? '/apply/voice-cloning/' : '/ai/voice-cloning/',
            },
        ],
    },
];
export default FJHeaderConfig;
